angular.module('logbook')
.directive('recurrenceFields', ['$timeout', "$http", "$location", "$window", "timeUnitService", 
function($timeout, $http, $location, $window, timeUnitService) {
  return {
    redirect: 'E',

    scope: {
       recurrenceSpec: '=',
       selectedLog: '=',
       previewRecurrence: '=',
       isSimple: '=',
       noRecurrences: '='
    },

	template: require('./recurrence-fields.html'),

    link: function(scope, elem, attrs) {
       scope.units = [
         {val: '', listVal: 'None', unitVal: ''},
         {val: 'DAY', listVal: 'Daily', unitVal: 'days'},
         {val: 'WEEK', listVal: 'Weekly', unitVal: 'weeks'},
         {val: 'MONTH', listVal: 'Monthly', unitVal: 'months'},
         {val: 'YEAR', listVal: 'Yearly', unitVal: 'years'}
       ];
       
       timeUnitService.getWeekdaysAndMonths().then(function(response) {
          scope.weekdays = response.weekdays.data;
          scope.months = response.months.data;
          
          scope.selectedDays = {};
       });
       
       scope.instances = [
          {id: 1, label: 'first'},
          {id: 2, label: 'second'},
          {id: 3, label: 'third'},
          {id: 4, label: 'fourth'},
          {id: 5, label: 'last'}
       ];
       
       scope.selectedUnit = scope.units[0];
       scope.selectedSingleDay = {};
       
       scope.clearRecurrencePreview = function()
       {
          scope.previewRecurrence.length = 0;
       };
       
       scope.daysUpdated = function() {
          scope.recurrenceSpec.daysOfWeek = [];
          Object.keys(scope.selectedDays).forEach(function(dayId) {
             if( dayId )
                scope.recurrenceSpec.daysOfWeek.push(dayId);
          });
       };
       
       scope.updateSingleDay = function() {
          scope.recurrenceSpec.daysOfWeek = [];
          scope.recurrenceSpec.daysOfWeek.push(scope.selectedSingleDay.id);
       };
       
       scope.getRadioStyle = function()
       {
          var style = {};
          if( scope.recurrenceSpec.unit == 'WEEK' 
              || scope.recurrenceSpec.unit == 'MONTH' 
                 || scope.recurrenceSpec.unit == 'YEAR')
             style['vertical-align'] = 'top';
          
          if( scope.recurrenceSpec.unit == 'MONTH'
             || scope.recurrenceSpec.unit == 'YEAR')
             style['margin-top'] = '1.5em';
          
          return style;
       };
       

    }
  }
}]);
